import { CreateAppEndAction } from "../actions/CreateApp";
import { AppState } from "../state";
import { addAppToState } from "./Common";

export function createApp(state: AppState, action: CreateAppEndAction): AppState {
    return addAppToState({ ...state, currentApp: action.payload.app }, action);
}
